// Componente para renderizar banderas de equipos usando Flagcdn
import React from 'react'

export default function Flag({ code, className = 'w-6 h-4 object-cover rounded shadow-sm inline-block mr-2 align-middle' }) {
  if (!code) return null

  // Si es un emoji (por ejemplo, longitud > 4 y no es código subnacional), lo mostramos directamente
  const isEmoji = code.length > 3 && !code.includes('-') && !code.includes('_')

  if (isEmoji) {
    return <span className="inline-block mr-1">{code}</span>
  }

  const cleanCode = code.trim().toLowerCase()
  return (
    <img
      src={`https://flagcdn.com/w80/${cleanCode}.png`}
      alt={code}
      className={className}
      onError={(e) => {
        // Ocultar si hay error de carga
        e.target.style.display = 'none'
      }}
    />
  )
}
